import { render, staticRenderFns } from "./RedirectPage.vue?vue&type=template&id=05141e18&scoped=true&"
import script from "./RedirectPage.vue?vue&type=script&lang=js&"
export * from "./RedirectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05141e18",
  null
  
)

export default component.exports